module.exports = __webpack_public_path__ + "img/logo.7d17c2e9.png";